import { Dispatch, SetStateAction } from "react";
import { EmailVariables } from "./EmailBuilderTypes";
import RecordDynamicBuilder from "./VariableBuilders/RecordDynamicBuilder";
import RecordValueBuilder from "./VariableBuilders/RecordValueBuilder";
import ValueBuilder from "./VariableBuilders/ValueBuilder";
import TemplateValueBuilder from "./VariableBuilders/TemplateValueBuilder";
import SearchByEmailBuilder from "./VariableBuilders/SearchByEmailBuilder";
import AppEmptyState from "../../../elements/AppEmptyState";

interface VariablesProps {
  variables: EmailVariables[];
  setVariables: Dispatch<SetStateAction<EmailVariables[]>>;
  customVariables?: string[];
  expandAll: boolean;
}

function EmailVariablesBuilder({
  variables,
  setVariables,
  customVariables,
  expandAll,
}: VariablesProps) {
  const hasVariables = Boolean(variables.length);

  return (
    <>
      {hasVariables ? (
        <div className="d-flex justify-content-between mt-2 font-weight-600 text-dark">
          <div style={{ paddingLeft: 45 }}>Variable Name</div>
          <div style={{ paddingRight: 60 }}>Variable Type</div>
        </div>
      ) : (
        <AppEmptyState
          title="No variables added!"
          description="Get started by adding a variable for the SendGrid template you are using."
          hideIcon
          className="mt-4"
        />
      )}
      {variables.map((variable, i) => {
        if (variable.Type === "RecordDynamic")
          return (
            <RecordDynamicBuilder
              key={i}
              variable={variable}
              index={i}
              setVariables={setVariables}
              customVariables={customVariables}
              expandAll={expandAll}
            />
          );

        if (variable.Type === "RecordValue")
          return (
            <RecordValueBuilder
              key={i}
              variable={variable}
              index={i}
              setVariables={setVariables}
              customVariables={customVariables}
              expandAll={expandAll}
            />
          );

        if (variable.Type === "Value")
          return (
            <ValueBuilder
              key={i}
              variable={variable}
              index={i}
              setVariables={setVariables}
              expandAll={expandAll}
            />
          );

        if (variable.Type === "TemplateValue")
          return (
            <TemplateValueBuilder
              key={i}
              variable={variable}
              variables={variables}
              index={i}
              setVariables={setVariables}
              customVariables={customVariables}
              expandAll={expandAll}
            />
          );

        if (variable.Type === "SearchByEmail")
          return (
            <SearchByEmailBuilder
              key={i}
              variable={variable}
              index={i}
              setVariables={setVariables}
              customVariables={customVariables}
              expandAll={expandAll}
            />
          );

        return null;
      })}
    </>
  );
}

export default EmailVariablesBuilder;
